
import kebabCase from 'lodash.kebabcase';
import type { ClickOrPressEvent } from 'types/mouseEvents';

// *****To update this file see `tools/generate-icon-imports.mjs`*****


// MCC Icons
import { ReactComponent as AccessibilityMcc } from 'assets/icons/mcc/accessibility.svg?react';
import { ReactComponent as AccessibleMcc } from 'assets/icons/mcc/accessible.svg?react';
import { ReactComponent as AddCardMcc } from 'assets/icons/mcc/add-card.svg?react';
import { ReactComponent as AddMcc } from 'assets/icons/mcc/add.svg?react';
import { ReactComponent as AflMcc } from 'assets/icons/mcc/afl.svg?react';
import { ReactComponent as AlarmClockMcc } from 'assets/icons/mcc/alarm-clock.svg?react';
import { ReactComponent as ArrowCursorMcc } from 'assets/icons/mcc/arrow-cursor.svg?react';
import { ReactComponent as ArrowDiagLeftDownMcc } from 'assets/icons/mcc/arrow-diag-left-down.svg?react';
import { ReactComponent as ArrowDiagLeftUpMcc } from 'assets/icons/mcc/arrow-diag-left-up.svg?react';
import { ReactComponent as ArrowDiagRightDownMcc } from 'assets/icons/mcc/arrow-diag-right-down.svg?react';
import { ReactComponent as ArrowDiagRightUpMcc } from 'assets/icons/mcc/arrow-diag-right-up.svg?react';
import { ReactComponent as ArrowDownMcc } from 'assets/icons/mcc/arrow-down.svg?react';
import { ReactComponent as ArrowExpandMcc } from 'assets/icons/mcc/arrow-expand.svg?react';
import { ReactComponent as ArrowLeftAltMcc } from 'assets/icons/mcc/arrow-left-alt.svg?react';
import { ReactComponent as ArrowLeftMcc } from 'assets/icons/mcc/arrow-left.svg?react';
import { ReactComponent as ArrowRightAltMcc } from 'assets/icons/mcc/arrow-right-alt.svg?react';
import { ReactComponent as ArrowRightMcc } from 'assets/icons/mcc/arrow-right.svg?react';
import { ReactComponent as ArrowUpMcc } from 'assets/icons/mcc/arrow-up.svg?react';
import { ReactComponent as AsmExperienceMcc } from 'assets/icons/mcc/asm-experience.svg?react';
import { ReactComponent as BeerMcc } from 'assets/icons/mcc/beer.svg?react';
import { ReactComponent as BellNotificationMcc } from 'assets/icons/mcc/bell-notification.svg?react';
import { ReactComponent as BookAndPencilMcc } from 'assets/icons/mcc/book-and-pencil.svg?react';
import { ReactComponent as BulletOutlineMcc } from 'assets/icons/mcc/bullet-outline.svg?react';
import { ReactComponent as BulletSolidMcc } from 'assets/icons/mcc/bullet-solid.svg?react';
import { ReactComponent as CalendarMarksMcc } from 'assets/icons/mcc/calendar-marks.svg?react';
import { ReactComponent as CalendarMcc } from 'assets/icons/mcc/calendar.svg?react';
import { ReactComponent as CarMcc } from 'assets/icons/mcc/car.svg?react';
import { ReactComponent as CashBillMcc } from 'assets/icons/mcc/cash-bill.svg?react';
import { ReactComponent as ChampagneMcc } from 'assets/icons/mcc/champagne.svg?react';
import { ReactComponent as ChatTwoBubblesMcc } from 'assets/icons/mcc/chat-two-bubbles.svg?react';
import { ReactComponent as ChatMcc } from 'assets/icons/mcc/chat.svg?react';
import { ReactComponent as CheckCircleMcc } from 'assets/icons/mcc/check-circle.svg?react';
import { ReactComponent as CheckSquareMcc } from 'assets/icons/mcc/check-square.svg?react';
import { ReactComponent as CheckMcc } from 'assets/icons/mcc/check.svg?react';
import { ReactComponent as ChecklistMcc } from 'assets/icons/mcc/checklist.svg?react';
import { ReactComponent as ChevronDownSmMcc } from 'assets/icons/mcc/chevron-down-sm.svg?react';
import { ReactComponent as ChevronDownMcc } from 'assets/icons/mcc/chevron-down.svg?react';
import { ReactComponent as ChevronLeftSmMcc } from 'assets/icons/mcc/chevron-left-sm.svg?react';
import { ReactComponent as ChevronLeftMcc } from 'assets/icons/mcc/chevron-left.svg?react';
import { ReactComponent as ChevronRightSmMcc } from 'assets/icons/mcc/chevron-right-sm.svg?react';
import { ReactComponent as ChevronRightMcc } from 'assets/icons/mcc/chevron-right.svg?react';
import { ReactComponent as ChevronUpSmMcc } from 'assets/icons/mcc/chevron-up-sm.svg?react';
import { ReactComponent as ChevronUpMcc } from 'assets/icons/mcc/chevron-up.svg?react';
import { ReactComponent as CloseMcc } from 'assets/icons/mcc/close.svg?react';
import { ReactComponent as ClubFunctionMcc } from 'assets/icons/mcc/club-function.svg?react';
import { ReactComponent as CreditCardMcc } from 'assets/icons/mcc/credit-card.svg?react';
import { ReactComponent as CricketMcc } from 'assets/icons/mcc/cricket.svg?react';
import { ReactComponent as CrossCircleMcc } from 'assets/icons/mcc/cross-circle.svg?react';
import { ReactComponent as DollarMcc } from 'assets/icons/mcc/dollar.svg?react';
import { ReactComponent as DoorOpenMcc } from 'assets/icons/mcc/door-open.svg?react';
import { ReactComponent as DownloadMcc } from 'assets/icons/mcc/download.svg?react';
import { ReactComponent as EditMcc } from 'assets/icons/mcc/edit.svg?react';
import { ReactComponent as EllipsesMcc } from 'assets/icons/mcc/ellipses.svg?react';
import { ReactComponent as ErrorCircleMcc } from 'assets/icons/mcc/error-circle.svg?react';
import { ReactComponent as ErrorMcc } from 'assets/icons/mcc/error.svg?react';
import { ReactComponent as ExperienceMcc } from 'assets/icons/mcc/experience.svg?react';
import { ReactComponent as ExportMcc } from 'assets/icons/mcc/export.svg?react';
import { ReactComponent as FamilyRoomMcc } from 'assets/icons/mcc/family-room.svg?react';
import { ReactComponent as FileCopyMcc } from 'assets/icons/mcc/file-copy.svg?react';
import { ReactComponent as FileMcc } from 'assets/icons/mcc/file.svg?react';
import { ReactComponent as FilterMcc } from 'assets/icons/mcc/filter.svg?react';
import { ReactComponent as FirstAidMcc } from 'assets/icons/mcc/first-aid.svg?react';
import { ReactComponent as FoodAndDrinkMcc } from 'assets/icons/mcc/food-and-drink.svg?react';
import { ReactComponent as ForkKnifeMcc } from 'assets/icons/mcc/fork-knife.svg?react';
import { ReactComponent as FriendMcc } from 'assets/icons/mcc/friend.svg?react';
import { ReactComponent as GlobeMcc } from 'assets/icons/mcc/globe.svg?react';
import { ReactComponent as HamburgerMcc } from 'assets/icons/mcc/hamburger.svg?react';
import { ReactComponent as HappyFaceMcc } from 'assets/icons/mcc/happy-face.svg?react';
import { ReactComponent as HeartInHandMcc } from 'assets/icons/mcc/heart-in-hand.svg?react';
import { ReactComponent as HeartSparkleMcc } from 'assets/icons/mcc/heart-sparkle.svg?react';
import { ReactComponent as HelpCircleMcc } from 'assets/icons/mcc/help-circle.svg?react';
import { ReactComponent as HomeMcc } from 'assets/icons/mcc/home.svg?react';
import { ReactComponent as HourglassMcc } from 'assets/icons/mcc/hourglass.svg?react';
import { ReactComponent as ImageMcc } from 'assets/icons/mcc/image.svg?react';
import { ReactComponent as InfoCircleMcc } from 'assets/icons/mcc/info-circle.svg?react';
import { ReactComponent as InfoSquareMcc } from 'assets/icons/mcc/info-square.svg?react';
import { ReactComponent as LinkMcc } from 'assets/icons/mcc/link.svg?react';
import { ReactComponent as LocationPin2Mcc } from 'assets/icons/mcc/location-pin-2.svg?react';
import { ReactComponent as LocationPinMcc } from 'assets/icons/mcc/location-pin.svg?react';
import { ReactComponent as LockMcc } from 'assets/icons/mcc/lock.svg?react';
import { ReactComponent as LogoutMcc } from 'assets/icons/mcc/logout.svg?react';
import { ReactComponent as MailMcc } from 'assets/icons/mcc/mail.svg?react';
import { ReactComponent as MapPinHollowMcc } from 'assets/icons/mcc/map-pin-hollow.svg?react';
import { ReactComponent as MapPinPlainMcc } from 'assets/icons/mcc/map-pin-plain.svg?react';
import { ReactComponent as MegaphoneMcc } from 'assets/icons/mcc/megaphone.svg?react';
import { ReactComponent as MembershipMcc } from 'assets/icons/mcc/membership.svg?react';
import { ReactComponent as MenuMcc } from 'assets/icons/mcc/menu.svg?react';
import { ReactComponent as MinusMcc } from 'assets/icons/mcc/minus.svg?react';
import { ReactComponent as Nearby2Mcc } from 'assets/icons/mcc/nearby-2.svg?react';
import { ReactComponent as NearbyMcc } from 'assets/icons/mcc/nearby.svg?react';
import { ReactComponent as NewsMcc } from 'assets/icons/mcc/news.svg?react';
import { ReactComponent as OfficeMcc } from 'assets/icons/mcc/office.svg?react';
import { ReactComponent as OpenInNewMcc } from 'assets/icons/mcc/open-in-new.svg?react';
import { ReactComponent as ParkingPRoundMcc } from 'assets/icons/mcc/parking-p-round.svg?react';
import { ReactComponent as PartyPopperMcc } from 'assets/icons/mcc/party-popper.svg?react';
import { ReactComponent as PauseMcc } from 'assets/icons/mcc/pause.svg?react';
import { ReactComponent as PhoneMcc } from 'assets/icons/mcc/phone.svg?react';
import { ReactComponent as PinMcc } from 'assets/icons/mcc/pin.svg?react';
import { ReactComponent as PlayMcc } from 'assets/icons/mcc/play.svg?react';
import { ReactComponent as PrayMcc } from 'assets/icons/mcc/pray.svg?react';
import { ReactComponent as ProcessingMcc } from 'assets/icons/mcc/processing.svg?react';
import { ReactComponent as RestartMcc } from 'assets/icons/mcc/restart.svg?react';
import { ReactComponent as RockNRollMcc } from 'assets/icons/mcc/rock-n-roll.svg?react';
import { ReactComponent as SearchMcc } from 'assets/icons/mcc/search.svg?react';
import { ReactComponent as SettingsMcc } from 'assets/icons/mcc/settings.svg?react';
import { ReactComponent as ShareMcc } from 'assets/icons/mcc/share.svg?react';
import { ReactComponent as ShieldMcc } from 'assets/icons/mcc/shield.svg?react';
import { ReactComponent as SocialFacebookMcc } from 'assets/icons/mcc/social-facebook.svg?react';
import { ReactComponent as SocialInstagramMcc } from 'assets/icons/mcc/social-instagram.svg?react';
import { ReactComponent as SocialLinkedinMcc } from 'assets/icons/mcc/social-linkedin.svg?react';
import { ReactComponent as SocialXMcc } from 'assets/icons/mcc/social-x.svg?react';
import { ReactComponent as SocialYoutubeMcc } from 'assets/icons/mcc/social-youtube.svg?react';
import { ReactComponent as StadiumOvalMcc } from 'assets/icons/mcc/stadium-oval.svg?react';
import { ReactComponent as StadiumMcc } from 'assets/icons/mcc/stadium.svg?react';
import { ReactComponent as StarMcc } from 'assets/icons/mcc/star.svg?react';
import { ReactComponent as TaillessArrowDownMcc } from 'assets/icons/mcc/tailless-arrow-down.svg?react';
import { ReactComponent as TaillessArrowLeftMcc } from 'assets/icons/mcc/tailless-arrow-left.svg?react';
import { ReactComponent as TaillessArrowRightMcc } from 'assets/icons/mcc/tailless-arrow-right.svg?react';
import { ReactComponent as TaillessArrowUpMcc } from 'assets/icons/mcc/tailless-arrow-up.svg?react';
import { ReactComponent as TeaCupMcc } from 'assets/icons/mcc/tea-cup.svg?react';
import { ReactComponent as TextSnippetMcc } from 'assets/icons/mcc/text-snippet.svg?react';
import { ReactComponent as ThumbsUpMcc } from 'assets/icons/mcc/thumbs-up.svg?react';
import { ReactComponent as TicketMcc } from 'assets/icons/mcc/ticket.svg?react';
import { ReactComponent as TieMcc } from 'assets/icons/mcc/tie.svg?react';
import { ReactComponent as TimeMcc } from 'assets/icons/mcc/time.svg?react';
import { ReactComponent as ToiletFemaleMcc } from 'assets/icons/mcc/toilet-female.svg?react';
import { ReactComponent as ToiletMaleMcc } from 'assets/icons/mcc/toilet-male.svg?react';
import { ReactComponent as ToiletMcc } from 'assets/icons/mcc/toilet.svg?react';
import { ReactComponent as TransactionHistoryMcc } from 'assets/icons/mcc/transaction-history.svg?react';
import { ReactComponent as TransferMcc } from 'assets/icons/mcc/transfer.svg?react';
import { ReactComponent as TrophyMcc } from 'assets/icons/mcc/trophy.svg?react';
import { ReactComponent as UnpinMcc } from 'assets/icons/mcc/unpin.svg?react';
import { ReactComponent as UserFemaleMcc } from 'assets/icons/mcc/user-female.svg?react';
import { ReactComponent as UserMaleMcc } from 'assets/icons/mcc/user-male.svg?react';
import { ReactComponent as VisibilityMcc } from 'assets/icons/mcc/visibility.svg?react';
import { ReactComponent as WarningMcc } from 'assets/icons/mcc/warning.svg?react';
import { ReactComponent as WeatherSunnyMcc } from 'assets/icons/mcc/weather-sunny.svg?react';
import { ReactComponent as WineMcc } from 'assets/icons/mcc/wine.svg?react';

// MCG Icons
import { ReactComponent as AccessibilityMcg } from 'assets/icons/mcg/accessibility.svg?react';
import { ReactComponent as AccessibleMcg } from 'assets/icons/mcg/accessible.svg?react';
import { ReactComponent as AddCardMcg } from 'assets/icons/mcg/add-card.svg?react';
import { ReactComponent as AddMcg } from 'assets/icons/mcg/add.svg?react';
import { ReactComponent as AflMcg } from 'assets/icons/mcg/afl.svg?react';
import { ReactComponent as AlarmClockMcg } from 'assets/icons/mcg/alarm-clock.svg?react';
import { ReactComponent as ArrowCursorMcg } from 'assets/icons/mcg/arrow-cursor.svg?react';
import { ReactComponent as ArrowDiagLeftDownMcg } from 'assets/icons/mcg/arrow-diag-left-down.svg?react';
import { ReactComponent as ArrowDiagLeftUpMcg } from 'assets/icons/mcg/arrow-diag-left-up.svg?react';
import { ReactComponent as ArrowDiagRightDownMcg } from 'assets/icons/mcg/arrow-diag-right-down.svg?react';
import { ReactComponent as ArrowDiagRightUpMcg } from 'assets/icons/mcg/arrow-diag-right-up.svg?react';
import { ReactComponent as ArrowDownMcg } from 'assets/icons/mcg/arrow-down.svg?react';
import { ReactComponent as ArrowExpandMcg } from 'assets/icons/mcg/arrow-expand.svg?react';
import { ReactComponent as ArrowLeftAltMcg } from 'assets/icons/mcg/arrow-left-alt.svg?react';
import { ReactComponent as ArrowLeftMcg } from 'assets/icons/mcg/arrow-left.svg?react';
import { ReactComponent as ArrowRightAltMcg } from 'assets/icons/mcg/arrow-right-alt.svg?react';
import { ReactComponent as ArrowRightMcg } from 'assets/icons/mcg/arrow-right.svg?react';
import { ReactComponent as ArrowUpMcg } from 'assets/icons/mcg/arrow-up.svg?react';
import { ReactComponent as AsmExperienceMcg } from 'assets/icons/mcg/asm-experience.svg?react';
import { ReactComponent as BeerMcg } from 'assets/icons/mcg/beer.svg?react';
import { ReactComponent as BellNotificationMcg } from 'assets/icons/mcg/bell-notification.svg?react';
import { ReactComponent as BookAndPencilMcg } from 'assets/icons/mcg/book-and-pencil.svg?react';
import { ReactComponent as BulletOutlineMcg } from 'assets/icons/mcg/bullet-outline.svg?react';
import { ReactComponent as BulletSolidMcg } from 'assets/icons/mcg/bullet-solid.svg?react';
import { ReactComponent as CalendarMarksMcg } from 'assets/icons/mcg/calendar-marks.svg?react';
import { ReactComponent as CalendarMcg } from 'assets/icons/mcg/calendar.svg?react';
import { ReactComponent as CarMcg } from 'assets/icons/mcg/car.svg?react';
import { ReactComponent as CashBillMcg } from 'assets/icons/mcg/cash-bill.svg?react';
import { ReactComponent as ChampagneMcg } from 'assets/icons/mcg/champagne.svg?react';
import { ReactComponent as ChatTwoBubblesMcg } from 'assets/icons/mcg/chat-two-bubbles.svg?react';
import { ReactComponent as ChatMcg } from 'assets/icons/mcg/chat.svg?react';
import { ReactComponent as CheckCircleMcg } from 'assets/icons/mcg/check-circle.svg?react';
import { ReactComponent as CheckSquareMcg } from 'assets/icons/mcg/check-square.svg?react';
import { ReactComponent as CheckMcg } from 'assets/icons/mcg/check.svg?react';
import { ReactComponent as ChecklistMcg } from 'assets/icons/mcg/checklist.svg?react';
import { ReactComponent as ChevronDownSmMcg } from 'assets/icons/mcg/chevron-down-sm.svg?react';
import { ReactComponent as ChevronDownMcg } from 'assets/icons/mcg/chevron-down.svg?react';
import { ReactComponent as ChevronLeftSmMcg } from 'assets/icons/mcg/chevron-left-sm.svg?react';
import { ReactComponent as ChevronLeftMcg } from 'assets/icons/mcg/chevron-left.svg?react';
import { ReactComponent as ChevronRightSmMcg } from 'assets/icons/mcg/chevron-right-sm.svg?react';
import { ReactComponent as ChevronRightMcg } from 'assets/icons/mcg/chevron-right.svg?react';
import { ReactComponent as ChevronUpSmMcg } from 'assets/icons/mcg/chevron-up-sm.svg?react';
import { ReactComponent as ChevronUpMcg } from 'assets/icons/mcg/chevron-up.svg?react';
import { ReactComponent as CloseMcg } from 'assets/icons/mcg/close.svg?react';
import { ReactComponent as ClubFunctionMcg } from 'assets/icons/mcg/club-function.svg?react';
import { ReactComponent as CreditCardMcg } from 'assets/icons/mcg/credit-card.svg?react';
import { ReactComponent as CricketMcg } from 'assets/icons/mcg/cricket.svg?react';
import { ReactComponent as CrossCircleMcg } from 'assets/icons/mcg/cross-circle.svg?react';
import { ReactComponent as DollarMcg } from 'assets/icons/mcg/dollar.svg?react';
import { ReactComponent as DoorOpenMcg } from 'assets/icons/mcg/door-open.svg?react';
import { ReactComponent as DownloadMcg } from 'assets/icons/mcg/download.svg?react';
import { ReactComponent as EditMcg } from 'assets/icons/mcg/edit.svg?react';
import { ReactComponent as EllipsesMcg } from 'assets/icons/mcg/ellipses.svg?react';
import { ReactComponent as ErrorCircleMcg } from 'assets/icons/mcg/error-circle.svg?react';
import { ReactComponent as ErrorMcg } from 'assets/icons/mcg/error.svg?react';
import { ReactComponent as ExperienceMcg } from 'assets/icons/mcg/experience.svg?react';
import { ReactComponent as ExportMcg } from 'assets/icons/mcg/export.svg?react';
import { ReactComponent as FamilyRoomMcg } from 'assets/icons/mcg/family-room.svg?react';
import { ReactComponent as FileCopyMcg } from 'assets/icons/mcg/file-copy.svg?react';
import { ReactComponent as FileMcg } from 'assets/icons/mcg/file.svg?react';
import { ReactComponent as FilterMcg } from 'assets/icons/mcg/filter.svg?react';
import { ReactComponent as FirstAidMcg } from 'assets/icons/mcg/first-aid.svg?react';
import { ReactComponent as FoodAndDrinkMcg } from 'assets/icons/mcg/food-and-drink.svg?react';
import { ReactComponent as ForkKnifeMcg } from 'assets/icons/mcg/fork-knife.svg?react';
import { ReactComponent as FriendMcg } from 'assets/icons/mcg/friend.svg?react';
import { ReactComponent as GlobeMcg } from 'assets/icons/mcg/globe.svg?react';
import { ReactComponent as HamburgerMcg } from 'assets/icons/mcg/hamburger.svg?react';
import { ReactComponent as HappyFaceMcg } from 'assets/icons/mcg/happy-face.svg?react';
import { ReactComponent as HeartInHandMcg } from 'assets/icons/mcg/heart-in-hand.svg?react';
import { ReactComponent as HeartSparkleMcg } from 'assets/icons/mcg/heart-sparkle.svg?react';
import { ReactComponent as HelpCircleMcg } from 'assets/icons/mcg/help-circle.svg?react';
import { ReactComponent as HomeMcg } from 'assets/icons/mcg/home.svg?react';
import { ReactComponent as HourglassMcg } from 'assets/icons/mcg/hourglass.svg?react';
import { ReactComponent as ImageMcg } from 'assets/icons/mcg/image.svg?react';
import { ReactComponent as InfoCircleMcg } from 'assets/icons/mcg/info-circle.svg?react';
import { ReactComponent as InfoSquareMcg } from 'assets/icons/mcg/info-square.svg?react';
import { ReactComponent as LinkMcg } from 'assets/icons/mcg/link.svg?react';
import { ReactComponent as LocationPin2Mcg } from 'assets/icons/mcg/location-pin-2.svg?react';
import { ReactComponent as LocationPinMcg } from 'assets/icons/mcg/location-pin.svg?react';
import { ReactComponent as LockMcg } from 'assets/icons/mcg/lock.svg?react';
import { ReactComponent as LogoutMcg } from 'assets/icons/mcg/logout.svg?react';
import { ReactComponent as MailMcg } from 'assets/icons/mcg/mail.svg?react';
import { ReactComponent as MapPinHollowMcg } from 'assets/icons/mcg/map-pin-hollow.svg?react';
import { ReactComponent as MapPinPlainMcg } from 'assets/icons/mcg/map-pin-plain.svg?react';
import { ReactComponent as MegaphoneMcg } from 'assets/icons/mcg/megaphone.svg?react';
import { ReactComponent as MembershipMcg } from 'assets/icons/mcg/membership.svg?react';
import { ReactComponent as MenuMcg } from 'assets/icons/mcg/menu.svg?react';
import { ReactComponent as MinusMcg } from 'assets/icons/mcg/minus.svg?react';
import { ReactComponent as Nearby2Mcg } from 'assets/icons/mcg/nearby-2.svg?react';
import { ReactComponent as NearbyMcg } from 'assets/icons/mcg/nearby.svg?react';
import { ReactComponent as NewsMcg } from 'assets/icons/mcg/news.svg?react';
import { ReactComponent as OfficeMcg } from 'assets/icons/mcg/office.svg?react';
import { ReactComponent as OpenInNewMcg } from 'assets/icons/mcg/open-in-new.svg?react';
import { ReactComponent as ParkingPRoundMcg } from 'assets/icons/mcg/parking-p-round.svg?react';
import { ReactComponent as PartyPopperMcg } from 'assets/icons/mcg/party-popper.svg?react';
import { ReactComponent as PauseMcg } from 'assets/icons/mcg/pause.svg?react';
import { ReactComponent as PhoneMcg } from 'assets/icons/mcg/phone.svg?react';
import { ReactComponent as PinMcg } from 'assets/icons/mcg/pin.svg?react';
import { ReactComponent as PlayMcg } from 'assets/icons/mcg/play.svg?react';
import { ReactComponent as PrayMcg } from 'assets/icons/mcg/pray.svg?react';
import { ReactComponent as ProcessingMcg } from 'assets/icons/mcg/processing.svg?react';
import { ReactComponent as RestartMcg } from 'assets/icons/mcg/restart.svg?react';
import { ReactComponent as RockNRollMcg } from 'assets/icons/mcg/rock-n-roll.svg?react';
import { ReactComponent as SearchMcg } from 'assets/icons/mcg/search.svg?react';
import { ReactComponent as SettingsMcg } from 'assets/icons/mcg/settings.svg?react';
import { ReactComponent as ShareMcg } from 'assets/icons/mcg/share.svg?react';
import { ReactComponent as ShieldMcg } from 'assets/icons/mcg/shield.svg?react';
import { ReactComponent as SocialFacebookMcg } from 'assets/icons/mcg/social-facebook.svg?react';
import { ReactComponent as SocialInstagramMcg } from 'assets/icons/mcg/social-instagram.svg?react';
import { ReactComponent as SocialLinkedinMcg } from 'assets/icons/mcg/social-linkedin.svg?react';
import { ReactComponent as SocialXMcg } from 'assets/icons/mcg/social-x.svg?react';
import { ReactComponent as SocialYoutubeMcg } from 'assets/icons/mcg/social-youtube.svg?react';
import { ReactComponent as StadiumOvalMcg } from 'assets/icons/mcg/stadium-oval.svg?react';
import { ReactComponent as StadiumMcg } from 'assets/icons/mcg/stadium.svg?react';
import { ReactComponent as StarMcg } from 'assets/icons/mcg/star.svg?react';
import { ReactComponent as TaillessArrowDownMcg } from 'assets/icons/mcg/tailless-arrow-down.svg?react';
import { ReactComponent as TaillessArrowLeftMcg } from 'assets/icons/mcg/tailless-arrow-left.svg?react';
import { ReactComponent as TaillessArrowRightMcg } from 'assets/icons/mcg/tailless-arrow-right.svg?react';
import { ReactComponent as TaillessArrowUpMcg } from 'assets/icons/mcg/tailless-arrow-up.svg?react';
import { ReactComponent as TeaCupMcg } from 'assets/icons/mcg/tea-cup.svg?react';
import { ReactComponent as TextSnippetMcg } from 'assets/icons/mcg/text-snippet.svg?react';
import { ReactComponent as ThumbsUpMcg } from 'assets/icons/mcg/thumbs-up.svg?react';
import { ReactComponent as TicketMcg } from 'assets/icons/mcg/ticket.svg?react';
import { ReactComponent as TieMcg } from 'assets/icons/mcg/tie.svg?react';
import { ReactComponent as TimeMcg } from 'assets/icons/mcg/time.svg?react';
import { ReactComponent as ToiletFemaleMcg } from 'assets/icons/mcg/toilet-female.svg?react';
import { ReactComponent as ToiletMaleMcg } from 'assets/icons/mcg/toilet-male.svg?react';
import { ReactComponent as ToiletMcg } from 'assets/icons/mcg/toilet.svg?react';
import { ReactComponent as TransactionHistoryMcg } from 'assets/icons/mcg/transaction-history.svg?react';
import { ReactComponent as TransferMcg } from 'assets/icons/mcg/transfer.svg?react';
import { ReactComponent as TrophyMcg } from 'assets/icons/mcg/trophy.svg?react';
import { ReactComponent as UnpinMcg } from 'assets/icons/mcg/unpin.svg?react';
import { ReactComponent as UserFemaleMcg } from 'assets/icons/mcg/user-female.svg?react';
import { ReactComponent as UserMaleMcg } from 'assets/icons/mcg/user-male.svg?react';
import { ReactComponent as VisibilityMcg } from 'assets/icons/mcg/visibility.svg?react';
import { ReactComponent as WarningMcg } from 'assets/icons/mcg/warning.svg?react';
import { ReactComponent as WeatherSunnyMcg } from 'assets/icons/mcg/weather-sunny.svg?react';
import { ReactComponent as WineMcg } from 'assets/icons/mcg/wine.svg?react';

// ASM Icons
import { ReactComponent as AccessibilityAsm } from 'assets/icons/asm/accessibility.svg?react';
import { ReactComponent as AccessibleAsm } from 'assets/icons/asm/accessible.svg?react';
import { ReactComponent as AddCardAsm } from 'assets/icons/asm/add-card.svg?react';
import { ReactComponent as AddAsm } from 'assets/icons/asm/add.svg?react';
import { ReactComponent as AflAsm } from 'assets/icons/asm/afl.svg?react';
import { ReactComponent as AlarmClockAsm } from 'assets/icons/asm/alarm-clock.svg?react';
import { ReactComponent as ArrowCursorAsm } from 'assets/icons/asm/arrow-cursor.svg?react';
import { ReactComponent as ArrowDiagLeftDownAsm } from 'assets/icons/asm/arrow-diag-left-down.svg?react';
import { ReactComponent as ArrowDiagLeftUpAsm } from 'assets/icons/asm/arrow-diag-left-up.svg?react';
import { ReactComponent as ArrowDiagRightDownAsm } from 'assets/icons/asm/arrow-diag-right-down.svg?react';
import { ReactComponent as ArrowDiagRightUpAsm } from 'assets/icons/asm/arrow-diag-right-up.svg?react';
import { ReactComponent as ArrowDownAsm } from 'assets/icons/asm/arrow-down.svg?react';
import { ReactComponent as ArrowExpandAsm } from 'assets/icons/asm/arrow-expand.svg?react';
import { ReactComponent as ArrowLeftAltAsm } from 'assets/icons/asm/arrow-left-alt.svg?react';
import { ReactComponent as ArrowLeftAsm } from 'assets/icons/asm/arrow-left.svg?react';
import { ReactComponent as ArrowRightAltAsm } from 'assets/icons/asm/arrow-right-alt.svg?react';
import { ReactComponent as ArrowRightAsm } from 'assets/icons/asm/arrow-right.svg?react';
import { ReactComponent as ArrowUpAsm } from 'assets/icons/asm/arrow-up.svg?react';
import { ReactComponent as AsmExperienceAsm } from 'assets/icons/asm/asm-experience.svg?react';
import { ReactComponent as BeerAsm } from 'assets/icons/asm/beer.svg?react';
import { ReactComponent as BellNotificationAsm } from 'assets/icons/asm/bell-notification.svg?react';
import { ReactComponent as BookAndPencilAsm } from 'assets/icons/asm/book-and-pencil.svg?react';
import { ReactComponent as BulletOutlineAsm } from 'assets/icons/asm/bullet-outline.svg?react';
import { ReactComponent as BulletSolidAsm } from 'assets/icons/asm/bullet-solid.svg?react';
import { ReactComponent as CalendarMarksAsm } from 'assets/icons/asm/calendar-marks.svg?react';
import { ReactComponent as CalendarAsm } from 'assets/icons/asm/calendar.svg?react';
import { ReactComponent as CarAsm } from 'assets/icons/asm/car.svg?react';
import { ReactComponent as CashBillAsm } from 'assets/icons/asm/cash-bill.svg?react';
import { ReactComponent as ChampagneAsm } from 'assets/icons/asm/champagne.svg?react';
import { ReactComponent as ChatTwoBubblesAsm } from 'assets/icons/asm/chat-two-bubbles.svg?react';
import { ReactComponent as ChatAsm } from 'assets/icons/asm/chat.svg?react';
import { ReactComponent as CheckCircleAsm } from 'assets/icons/asm/check-circle.svg?react';
import { ReactComponent as CheckSquareAsm } from 'assets/icons/asm/check-square.svg?react';
import { ReactComponent as CheckAsm } from 'assets/icons/asm/check.svg?react';
import { ReactComponent as ChecklistAsm } from 'assets/icons/asm/checklist.svg?react';
import { ReactComponent as ChevronDownSmAsm } from 'assets/icons/asm/chevron-down-sm.svg?react';
import { ReactComponent as ChevronDownAsm } from 'assets/icons/asm/chevron-down.svg?react';
import { ReactComponent as ChevronLeftSmAsm } from 'assets/icons/asm/chevron-left-sm.svg?react';
import { ReactComponent as ChevronLeftAsm } from 'assets/icons/asm/chevron-left.svg?react';
import { ReactComponent as ChevronRightSmAsm } from 'assets/icons/asm/chevron-right-sm.svg?react';
import { ReactComponent as ChevronRightAsm } from 'assets/icons/asm/chevron-right.svg?react';
import { ReactComponent as ChevronUpSmAsm } from 'assets/icons/asm/chevron-up-sm.svg?react';
import { ReactComponent as ChevronUpAsm } from 'assets/icons/asm/chevron-up.svg?react';
import { ReactComponent as CloseAsm } from 'assets/icons/asm/close.svg?react';
import { ReactComponent as ClubFunctionAsm } from 'assets/icons/asm/club-function.svg?react';
import { ReactComponent as CreditCardAsm } from 'assets/icons/asm/credit-card.svg?react';
import { ReactComponent as CricketAsm } from 'assets/icons/asm/cricket.svg?react';
import { ReactComponent as CrossCircleAsm } from 'assets/icons/asm/cross-circle.svg?react';
import { ReactComponent as DollarAsm } from 'assets/icons/asm/dollar.svg?react';
import { ReactComponent as DoorOpenAsm } from 'assets/icons/asm/door-open.svg?react';
import { ReactComponent as DownloadAsm } from 'assets/icons/asm/download.svg?react';
import { ReactComponent as EditAsm } from 'assets/icons/asm/edit.svg?react';
import { ReactComponent as EllipsesAsm } from 'assets/icons/asm/ellipses.svg?react';
import { ReactComponent as ErrorCircleAsm } from 'assets/icons/asm/error-circle.svg?react';
import { ReactComponent as ErrorAsm } from 'assets/icons/asm/error.svg?react';
import { ReactComponent as ExperienceAsm } from 'assets/icons/asm/experience.svg?react';
import { ReactComponent as ExportAsm } from 'assets/icons/asm/export.svg?react';
import { ReactComponent as FamilyRoomAsm } from 'assets/icons/asm/family-room.svg?react';
import { ReactComponent as FileCopyAsm } from 'assets/icons/asm/file-copy.svg?react';
import { ReactComponent as FileAsm } from 'assets/icons/asm/file.svg?react';
import { ReactComponent as FilterAsm } from 'assets/icons/asm/filter.svg?react';
import { ReactComponent as FirstAidAsm } from 'assets/icons/asm/first-aid.svg?react';
import { ReactComponent as FoodAndDrinkAsm } from 'assets/icons/asm/food-and-drink.svg?react';
import { ReactComponent as ForkKnifeAsm } from 'assets/icons/asm/fork-knife.svg?react';
import { ReactComponent as FriendAsm } from 'assets/icons/asm/friend.svg?react';
import { ReactComponent as GlobeAsm } from 'assets/icons/asm/globe.svg?react';
import { ReactComponent as HamburgerAsm } from 'assets/icons/asm/hamburger.svg?react';
import { ReactComponent as HappyFaceAsm } from 'assets/icons/asm/happy-face.svg?react';
import { ReactComponent as HeartInHandAsm } from 'assets/icons/asm/heart-in-hand.svg?react';
import { ReactComponent as HeartSparkleAsm } from 'assets/icons/asm/heart-sparkle.svg?react';
import { ReactComponent as HelpCircleAsm } from 'assets/icons/asm/help-circle.svg?react';
import { ReactComponent as HomeAsm } from 'assets/icons/asm/home.svg?react';
import { ReactComponent as HourglassAsm } from 'assets/icons/asm/hourglass.svg?react';
import { ReactComponent as ImageAsm } from 'assets/icons/asm/image.svg?react';
import { ReactComponent as InfoCircleAsm } from 'assets/icons/asm/info-circle.svg?react';
import { ReactComponent as InfoSquareAsm } from 'assets/icons/asm/info-square.svg?react';
import { ReactComponent as LinkAsm } from 'assets/icons/asm/link.svg?react';
import { ReactComponent as LocationPin2Asm } from 'assets/icons/asm/location-pin-2.svg?react';
import { ReactComponent as LocationPinAsm } from 'assets/icons/asm/location-pin.svg?react';
import { ReactComponent as LockAsm } from 'assets/icons/asm/lock.svg?react';
import { ReactComponent as LogoutAsm } from 'assets/icons/asm/logout.svg?react';
import { ReactComponent as MailAsm } from 'assets/icons/asm/mail.svg?react';
import { ReactComponent as MapPinHollowAsm } from 'assets/icons/asm/map-pin-hollow.svg?react';
import { ReactComponent as MapPinPlainAsm } from 'assets/icons/asm/map-pin-plain.svg?react';
import { ReactComponent as MegaphoneAsm } from 'assets/icons/asm/megaphone.svg?react';
import { ReactComponent as MembershipAsm } from 'assets/icons/asm/membership.svg?react';
import { ReactComponent as MenuAsm } from 'assets/icons/asm/menu.svg?react';
import { ReactComponent as MinusAsm } from 'assets/icons/asm/minus.svg?react';
import { ReactComponent as Nearby2Asm } from 'assets/icons/asm/nearby-2.svg?react';
import { ReactComponent as NearbyAsm } from 'assets/icons/asm/nearby.svg?react';
import { ReactComponent as NewsAsm } from 'assets/icons/asm/news.svg?react';
import { ReactComponent as OfficeAsm } from 'assets/icons/asm/office.svg?react';
import { ReactComponent as OpenInNewAsm } from 'assets/icons/asm/open-in-new.svg?react';
import { ReactComponent as ParkingPRoundAsm } from 'assets/icons/asm/parking-p-round.svg?react';
import { ReactComponent as PartyPopperAsm } from 'assets/icons/asm/party-popper.svg?react';
import { ReactComponent as PauseAsm } from 'assets/icons/asm/pause.svg?react';
import { ReactComponent as PhoneAsm } from 'assets/icons/asm/phone.svg?react';
import { ReactComponent as PinAsm } from 'assets/icons/asm/pin.svg?react';
import { ReactComponent as PlayAsm } from 'assets/icons/asm/play.svg?react';
import { ReactComponent as PrayAsm } from 'assets/icons/asm/pray.svg?react';
import { ReactComponent as ProcessingAsm } from 'assets/icons/asm/processing.svg?react';
import { ReactComponent as RestartAsm } from 'assets/icons/asm/restart.svg?react';
import { ReactComponent as RockNRollAsm } from 'assets/icons/asm/rock-n-roll.svg?react';
import { ReactComponent as SearchAsm } from 'assets/icons/asm/search.svg?react';
import { ReactComponent as SettingsAsm } from 'assets/icons/asm/settings.svg?react';
import { ReactComponent as ShareAsm } from 'assets/icons/asm/share.svg?react';
import { ReactComponent as ShieldAsm } from 'assets/icons/asm/shield.svg?react';
import { ReactComponent as SocialFacebookAsm } from 'assets/icons/asm/social-facebook.svg?react';
import { ReactComponent as SocialInstagramAsm } from 'assets/icons/asm/social-instagram.svg?react';
import { ReactComponent as SocialLinkedinAsm } from 'assets/icons/asm/social-linkedin.svg?react';
import { ReactComponent as SocialXAsm } from 'assets/icons/asm/social-x.svg?react';
import { ReactComponent as SocialYoutubeAsm } from 'assets/icons/asm/social-youtube.svg?react';
import { ReactComponent as StadiumOvalAsm } from 'assets/icons/asm/stadium-oval.svg?react';
import { ReactComponent as StadiumAsm } from 'assets/icons/asm/stadium.svg?react';
import { ReactComponent as StarAsm } from 'assets/icons/asm/star.svg?react';
import { ReactComponent as TaillessArrowDownAsm } from 'assets/icons/asm/tailless-arrow-down.svg?react';
import { ReactComponent as TaillessArrowLeftAsm } from 'assets/icons/asm/tailless-arrow-left.svg?react';
import { ReactComponent as TaillessArrowRightAsm } from 'assets/icons/asm/tailless-arrow-right.svg?react';
import { ReactComponent as TaillessArrowUpAsm } from 'assets/icons/asm/tailless-arrow-up.svg?react';
import { ReactComponent as TeaCupAsm } from 'assets/icons/asm/tea-cup.svg?react';
import { ReactComponent as TextSnippetAsm } from 'assets/icons/asm/text-snippet.svg?react';
import { ReactComponent as ThumbsUpAsm } from 'assets/icons/asm/thumbs-up.svg?react';
import { ReactComponent as TicketAsm } from 'assets/icons/asm/ticket.svg?react';
import { ReactComponent as TieAsm } from 'assets/icons/asm/tie.svg?react';
import { ReactComponent as TimeAsm } from 'assets/icons/asm/time.svg?react';
import { ReactComponent as ToiletFemaleAsm } from 'assets/icons/asm/toilet-female.svg?react';
import { ReactComponent as ToiletMaleAsm } from 'assets/icons/asm/toilet-male.svg?react';
import { ReactComponent as ToiletAsm } from 'assets/icons/asm/toilet.svg?react';
import { ReactComponent as TransactionHistoryAsm } from 'assets/icons/asm/transaction-history.svg?react';
import { ReactComponent as TransferAsm } from 'assets/icons/asm/transfer.svg?react';
import { ReactComponent as TrophyAsm } from 'assets/icons/asm/trophy.svg?react';
import { ReactComponent as UnpinAsm } from 'assets/icons/asm/unpin.svg?react';
import { ReactComponent as UserFemaleAsm } from 'assets/icons/asm/user-female.svg?react';
import { ReactComponent as UserMaleAsm } from 'assets/icons/asm/user-male.svg?react';
import { ReactComponent as VisibilityAsm } from 'assets/icons/asm/visibility.svg?react';
import { ReactComponent as WarningAsm } from 'assets/icons/asm/warning.svg?react';
import { ReactComponent as WeatherSunnyAsm } from 'assets/icons/asm/weather-sunny.svg?react';
import { ReactComponent as WineAsm } from 'assets/icons/asm/wine.svg?react';

export type IconString =

| 'accessibility'
| 'accessible'
| 'add'
| 'add-card'
| 'afl'
| 'alarm-clock'
| 'arrow-cursor'
| 'arrow-diag-left-down'
| 'arrow-diag-left-up'
| 'arrow-diag-right-down'
| 'arrow-diag-right-up'
| 'arrow-down'
| 'arrow-expand'
| 'arrow-left'
| 'arrow-left-alt'
| 'arrow-right'
| 'arrow-right-alt'
| 'arrow-up'
| 'asm-experience'
| 'beer'
| 'bell-notification'
| 'book-and-pencil'
| 'bullet-outline'
| 'bullet-solid'
| 'calendar'
| 'calendar-marks'
| 'car'
| 'cash-bill'
| 'champagne'
| 'chat'
| 'chat-two-bubbles'
| 'check'
| 'check-circle'
| 'check-square'
| 'checklist'
| 'chevron-down'
| 'chevron-down-sm'
| 'chevron-left'
| 'chevron-left-sm'
| 'chevron-right'
| 'chevron-right-sm'
| 'chevron-up'
| 'chevron-up-sm'
| 'close'
| 'club-function'
| 'credit-card'
| 'cricket'
| 'cross-circle'
| 'dollar'
| 'door-open'
| 'download'
| 'edit'
| 'ellipses'
| 'error'
| 'error-circle'
| 'experience'
| 'export'
| 'family-room'
| 'file'
| 'file-copy'
| 'filter'
| 'first-aid'
| 'food-and-drink'
| 'fork-knife'
| 'friend'
| 'globe'
| 'hamburger'
| 'happy-face'
| 'heart-in-hand'
| 'heart-sparkle'
| 'help-circle'
| 'home'
| 'hourglass'
| 'image'
| 'info-circle'
| 'info-square'
| 'link'
| 'location-pin'
| 'location-pin-2'
| 'lock'
| 'logout'
| 'mail'
| 'map-pin-hollow'
| 'map-pin-plain'
| 'megaphone'
| 'membership'
| 'menu'
| 'minus'
| 'nearby'
| 'nearby-2'
| 'news'
| 'office'
| 'open-in-new'
| 'parking-p-round'
| 'party-popper'
| 'pause'
| 'phone'
| 'pin'
| 'play'
| 'pray'
| 'processing'
| 'restart'
| 'rock-n-roll'
| 'search'
| 'settings'
| 'share'
| 'shield'
| 'social-facebook'
| 'social-instagram'
| 'social-linkedin'
| 'social-x'
| 'social-youtube'
| 'stadium'
| 'stadium-oval'
| 'star'
| 'tailless-arrow-down'
| 'tailless-arrow-left'
| 'tailless-arrow-right'
| 'tailless-arrow-up'
| 'tea-cup'
| 'text-snippet'
| 'thumbs-up'
| 'ticket'
| 'tie'
| 'time'
| 'toilet'
| 'toilet-female'
| 'toilet-male'
| 'transaction-history'
| 'transfer'
| 'trophy'
| 'unpin'
| 'user-female'
| 'user-male'
| 'visibility'
| 'warning'
| 'weather-sunny'
| 'wine';

export type IconSVG = React.FunctionComponent<React.SVGProps<SVGSVGElement>>;

export const allIconComponentsMcc: Record<IconString, IconSVG> = {
    accessibility: AccessibilityMcc,
    accessible: AccessibleMcc,
    'add-card': AddCardMcc,
    add: AddMcc,
    afl: AflMcc,
    'alarm-clock': AlarmClockMcc,
    'arrow-cursor': ArrowCursorMcc,
    'arrow-diag-left-down': ArrowDiagLeftDownMcc,
    'arrow-diag-left-up': ArrowDiagLeftUpMcc,
    'arrow-diag-right-down': ArrowDiagRightDownMcc,
    'arrow-diag-right-up': ArrowDiagRightUpMcc,
    'arrow-down': ArrowDownMcc,
    'arrow-expand': ArrowExpandMcc,
    'arrow-left-alt': ArrowLeftAltMcc,
    'arrow-left': ArrowLeftMcc,
    'arrow-right-alt': ArrowRightAltMcc,
    'arrow-right': ArrowRightMcc,
    'arrow-up': ArrowUpMcc,
    'asm-experience': AsmExperienceMcc,
    beer: BeerMcc,
    'bell-notification': BellNotificationMcc,
    'book-and-pencil': BookAndPencilMcc,
    'bullet-outline': BulletOutlineMcc,
    'bullet-solid': BulletSolidMcc,
    'calendar-marks': CalendarMarksMcc,
    calendar: CalendarMcc,
    car: CarMcc,
    'cash-bill': CashBillMcc,
    champagne: ChampagneMcc,
    'chat-two-bubbles': ChatTwoBubblesMcc,
    chat: ChatMcc,
    'check-circle': CheckCircleMcc,
    'check-square': CheckSquareMcc,
    check: CheckMcc,
    checklist: ChecklistMcc,
    'chevron-down-sm': ChevronDownSmMcc,
    'chevron-down': ChevronDownMcc,
    'chevron-left-sm': ChevronLeftSmMcc,
    'chevron-left': ChevronLeftMcc,
    'chevron-right-sm': ChevronRightSmMcc,
    'chevron-right': ChevronRightMcc,
    'chevron-up-sm': ChevronUpSmMcc,
    'chevron-up': ChevronUpMcc,
    close: CloseMcc,
    'club-function': ClubFunctionMcc,
    'credit-card': CreditCardMcc,
    cricket: CricketMcc,
    'cross-circle': CrossCircleMcc,
    dollar: DollarMcc,
    'door-open': DoorOpenMcc,
    download: DownloadMcc,
    edit: EditMcc,
    ellipses: EllipsesMcc,
    'error-circle': ErrorCircleMcc,
    error: ErrorMcc,
    experience: ExperienceMcc,
    export: ExportMcc,
    'family-room': FamilyRoomMcc,
    'file-copy': FileCopyMcc,
    file: FileMcc,
    filter: FilterMcc,
    'first-aid': FirstAidMcc,
    'food-and-drink': FoodAndDrinkMcc,
    'fork-knife': ForkKnifeMcc,
    friend: FriendMcc,
    globe: GlobeMcc,
    hamburger: HamburgerMcc,
    'happy-face': HappyFaceMcc,
    'heart-in-hand': HeartInHandMcc,
    'heart-sparkle': HeartSparkleMcc,
    'help-circle': HelpCircleMcc,
    home: HomeMcc,
    hourglass: HourglassMcc,
    image: ImageMcc,
    'info-circle': InfoCircleMcc,
    'info-square': InfoSquareMcc,
    link: LinkMcc,
    'location-pin-2': LocationPin2Mcc,
    'location-pin': LocationPinMcc,
    lock: LockMcc,
    logout: LogoutMcc,
    mail: MailMcc,
    'map-pin-hollow': MapPinHollowMcc,
    'map-pin-plain': MapPinPlainMcc,
    megaphone: MegaphoneMcc,
    membership: MembershipMcc,
    menu: MenuMcc,
    minus: MinusMcc,
    'nearby-2': Nearby2Mcc,
    nearby: NearbyMcc,
    news: NewsMcc,
    office: OfficeMcc,
    'open-in-new': OpenInNewMcc,
    'parking-p-round': ParkingPRoundMcc,
    'party-popper': PartyPopperMcc,
    pause: PauseMcc,
    phone: PhoneMcc,
    pin: PinMcc,
    play: PlayMcc,
    pray: PrayMcc,
    processing: ProcessingMcc,
    restart: RestartMcc,
    'rock-n-roll': RockNRollMcc,
    search: SearchMcc,
    settings: SettingsMcc,
    share: ShareMcc,
    shield: ShieldMcc,
    'social-facebook': SocialFacebookMcc,
    'social-instagram': SocialInstagramMcc,
    'social-linkedin': SocialLinkedinMcc,
    'social-x': SocialXMcc,
    'social-youtube': SocialYoutubeMcc,
    'stadium-oval': StadiumOvalMcc,
    stadium: StadiumMcc,
    star: StarMcc,
    'tailless-arrow-down': TaillessArrowDownMcc,
    'tailless-arrow-left': TaillessArrowLeftMcc,
    'tailless-arrow-right': TaillessArrowRightMcc,
    'tailless-arrow-up': TaillessArrowUpMcc,
    'tea-cup': TeaCupMcc,
    'text-snippet': TextSnippetMcc,
    'thumbs-up': ThumbsUpMcc,
    ticket: TicketMcc,
    tie: TieMcc,
    time: TimeMcc,
    'toilet-female': ToiletFemaleMcc,
    'toilet-male': ToiletMaleMcc,
    toilet: ToiletMcc,
    'transaction-history': TransactionHistoryMcc,
    transfer: TransferMcc,
    trophy: TrophyMcc,
    unpin: UnpinMcc,
    'user-female': UserFemaleMcc,
    'user-male': UserMaleMcc,
    visibility: VisibilityMcc,
    warning: WarningMcc,
    'weather-sunny': WeatherSunnyMcc,
    wine: WineMcc,
};

export const allIconComponentsMcg: Record<IconString, IconSVG> = {
    accessibility: AccessibilityMcg,
    accessible: AccessibleMcg,
    'add-card': AddCardMcg,
    add: AddMcg,
    afl: AflMcg,
    'alarm-clock': AlarmClockMcg,
    'arrow-cursor': ArrowCursorMcg,
    'arrow-diag-left-down': ArrowDiagLeftDownMcg,
    'arrow-diag-left-up': ArrowDiagLeftUpMcg,
    'arrow-diag-right-down': ArrowDiagRightDownMcg,
    'arrow-diag-right-up': ArrowDiagRightUpMcg,
    'arrow-down': ArrowDownMcg,
    'arrow-expand': ArrowExpandMcg,
    'arrow-left-alt': ArrowLeftAltMcg,
    'arrow-left': ArrowLeftMcg,
    'arrow-right-alt': ArrowRightAltMcg,
    'arrow-right': ArrowRightMcg,
    'arrow-up': ArrowUpMcg,
    'asm-experience': AsmExperienceMcg,
    beer: BeerMcg,
    'bell-notification': BellNotificationMcg,
    'book-and-pencil': BookAndPencilMcg,
    'bullet-outline': BulletOutlineMcg,
    'bullet-solid': BulletSolidMcg,
    'calendar-marks': CalendarMarksMcg,
    calendar: CalendarMcg,
    car: CarMcg,
    'cash-bill': CashBillMcg,
    champagne: ChampagneMcg,
    'chat-two-bubbles': ChatTwoBubblesMcg,
    chat: ChatMcg,
    'check-circle': CheckCircleMcg,
    'check-square': CheckSquareMcg,
    check: CheckMcg,
    checklist: ChecklistMcg,
    'chevron-down-sm': ChevronDownSmMcg,
    'chevron-down': ChevronDownMcg,
    'chevron-left-sm': ChevronLeftSmMcg,
    'chevron-left': ChevronLeftMcg,
    'chevron-right-sm': ChevronRightSmMcg,
    'chevron-right': ChevronRightMcg,
    'chevron-up-sm': ChevronUpSmMcg,
    'chevron-up': ChevronUpMcg,
    close: CloseMcg,
    'club-function': ClubFunctionMcg,
    'credit-card': CreditCardMcg,
    cricket: CricketMcg,
    'cross-circle': CrossCircleMcg,
    dollar: DollarMcg,
    'door-open': DoorOpenMcg,
    download: DownloadMcg,
    edit: EditMcg,
    ellipses: EllipsesMcg,
    'error-circle': ErrorCircleMcg,
    error: ErrorMcg,
    experience: ExperienceMcg,
    export: ExportMcg,
    'family-room': FamilyRoomMcg,
    'file-copy': FileCopyMcg,
    file: FileMcg,
    filter: FilterMcg,
    'first-aid': FirstAidMcg,
    'food-and-drink': FoodAndDrinkMcg,
    'fork-knife': ForkKnifeMcg,
    friend: FriendMcg,
    globe: GlobeMcg,
    hamburger: HamburgerMcg,
    'happy-face': HappyFaceMcg,
    'heart-in-hand': HeartInHandMcg,
    'heart-sparkle': HeartSparkleMcg,
    'help-circle': HelpCircleMcg,
    home: HomeMcg,
    hourglass: HourglassMcg,
    image: ImageMcg,
    'info-circle': InfoCircleMcg,
    'info-square': InfoSquareMcg,
    link: LinkMcg,
    'location-pin-2': LocationPin2Mcg,
    'location-pin': LocationPinMcg,
    lock: LockMcg,
    logout: LogoutMcg,
    mail: MailMcg,
    'map-pin-hollow': MapPinHollowMcg,
    'map-pin-plain': MapPinPlainMcg,
    megaphone: MegaphoneMcg,
    membership: MembershipMcg,
    menu: MenuMcg,
    minus: MinusMcg,
    'nearby-2': Nearby2Mcg,
    nearby: NearbyMcg,
    news: NewsMcg,
    office: OfficeMcg,
    'open-in-new': OpenInNewMcg,
    'parking-p-round': ParkingPRoundMcg,
    'party-popper': PartyPopperMcg,
    pause: PauseMcg,
    phone: PhoneMcg,
    pin: PinMcg,
    play: PlayMcg,
    pray: PrayMcg,
    processing: ProcessingMcg,
    restart: RestartMcg,
    'rock-n-roll': RockNRollMcg,
    search: SearchMcg,
    settings: SettingsMcg,
    share: ShareMcg,
    shield: ShieldMcg,
    'social-facebook': SocialFacebookMcg,
    'social-instagram': SocialInstagramMcg,
    'social-linkedin': SocialLinkedinMcg,
    'social-x': SocialXMcg,
    'social-youtube': SocialYoutubeMcg,
    'stadium-oval': StadiumOvalMcg,
    stadium: StadiumMcg,
    star: StarMcg,
    'tailless-arrow-down': TaillessArrowDownMcg,
    'tailless-arrow-left': TaillessArrowLeftMcg,
    'tailless-arrow-right': TaillessArrowRightMcg,
    'tailless-arrow-up': TaillessArrowUpMcg,
    'tea-cup': TeaCupMcg,
    'text-snippet': TextSnippetMcg,
    'thumbs-up': ThumbsUpMcg,
    ticket: TicketMcg,
    tie: TieMcg,
    time: TimeMcg,
    'toilet-female': ToiletFemaleMcg,
    'toilet-male': ToiletMaleMcg,
    toilet: ToiletMcg,
    'transaction-history': TransactionHistoryMcg,
    transfer: TransferMcg,
    trophy: TrophyMcg,
    unpin: UnpinMcg,
    'user-female': UserFemaleMcg,
    'user-male': UserMaleMcg,
    visibility: VisibilityMcg,
    warning: WarningMcg,
    'weather-sunny': WeatherSunnyMcg,
    wine: WineMcg,
};

export const allIconComponentsAsm: Record<IconString, IconSVG> = {
    accessibility: AccessibilityAsm,
    accessible: AccessibleAsm,
    'add-card': AddCardAsm,
    add: AddAsm,
    afl: AflAsm,
    'alarm-clock': AlarmClockAsm,
    'arrow-cursor': ArrowCursorAsm,
    'arrow-diag-left-down': ArrowDiagLeftDownAsm,
    'arrow-diag-left-up': ArrowDiagLeftUpAsm,
    'arrow-diag-right-down': ArrowDiagRightDownAsm,
    'arrow-diag-right-up': ArrowDiagRightUpAsm,
    'arrow-down': ArrowDownAsm,
    'arrow-expand': ArrowExpandAsm,
    'arrow-left-alt': ArrowLeftAltAsm,
    'arrow-left': ArrowLeftAsm,
    'arrow-right-alt': ArrowRightAltAsm,
    'arrow-right': ArrowRightAsm,
    'arrow-up': ArrowUpAsm,
    'asm-experience': AsmExperienceAsm,
    beer: BeerAsm,
    'bell-notification': BellNotificationAsm,
    'book-and-pencil': BookAndPencilAsm,
    'bullet-outline': BulletOutlineAsm,
    'bullet-solid': BulletSolidAsm,
    'calendar-marks': CalendarMarksAsm,
    calendar: CalendarAsm,
    car: CarAsm,
    'cash-bill': CashBillAsm,
    champagne: ChampagneAsm,
    'chat-two-bubbles': ChatTwoBubblesAsm,
    chat: ChatAsm,
    'check-circle': CheckCircleAsm,
    'check-square': CheckSquareAsm,
    check: CheckAsm,
    checklist: ChecklistAsm,
    'chevron-down-sm': ChevronDownSmAsm,
    'chevron-down': ChevronDownAsm,
    'chevron-left-sm': ChevronLeftSmAsm,
    'chevron-left': ChevronLeftAsm,
    'chevron-right-sm': ChevronRightSmAsm,
    'chevron-right': ChevronRightAsm,
    'chevron-up-sm': ChevronUpSmAsm,
    'chevron-up': ChevronUpAsm,
    close: CloseAsm,
    'club-function': ClubFunctionAsm,
    'credit-card': CreditCardAsm,
    cricket: CricketAsm,
    'cross-circle': CrossCircleAsm,
    dollar: DollarAsm,
    'door-open': DoorOpenAsm,
    download: DownloadAsm,
    edit: EditAsm,
    ellipses: EllipsesAsm,
    'error-circle': ErrorCircleAsm,
    error: ErrorAsm,
    experience: ExperienceAsm,
    export: ExportAsm,
    'family-room': FamilyRoomAsm,
    'file-copy': FileCopyAsm,
    file: FileAsm,
    filter: FilterAsm,
    'first-aid': FirstAidAsm,
    'food-and-drink': FoodAndDrinkAsm,
    'fork-knife': ForkKnifeAsm,
    friend: FriendAsm,
    globe: GlobeAsm,
    hamburger: HamburgerAsm,
    'happy-face': HappyFaceAsm,
    'heart-in-hand': HeartInHandAsm,
    'heart-sparkle': HeartSparkleAsm,
    'help-circle': HelpCircleAsm,
    home: HomeAsm,
    hourglass: HourglassAsm,
    image: ImageAsm,
    'info-circle': InfoCircleAsm,
    'info-square': InfoSquareAsm,
    link: LinkAsm,
    'location-pin-2': LocationPin2Asm,
    'location-pin': LocationPinAsm,
    lock: LockAsm,
    logout: LogoutAsm,
    mail: MailAsm,
    'map-pin-hollow': MapPinHollowAsm,
    'map-pin-plain': MapPinPlainAsm,
    megaphone: MegaphoneAsm,
    membership: MembershipAsm,
    menu: MenuAsm,
    minus: MinusAsm,
    'nearby-2': Nearby2Asm,
    nearby: NearbyAsm,
    news: NewsAsm,
    office: OfficeAsm,
    'open-in-new': OpenInNewAsm,
    'parking-p-round': ParkingPRoundAsm,
    'party-popper': PartyPopperAsm,
    pause: PauseAsm,
    phone: PhoneAsm,
    pin: PinAsm,
    play: PlayAsm,
    pray: PrayAsm,
    processing: ProcessingAsm,
    restart: RestartAsm,
    'rock-n-roll': RockNRollAsm,
    search: SearchAsm,
    settings: SettingsAsm,
    share: ShareAsm,
    shield: ShieldAsm,
    'social-facebook': SocialFacebookAsm,
    'social-instagram': SocialInstagramAsm,
    'social-linkedin': SocialLinkedinAsm,
    'social-x': SocialXAsm,
    'social-youtube': SocialYoutubeAsm,
    'stadium-oval': StadiumOvalAsm,
    stadium: StadiumAsm,
    star: StarAsm,
    'tailless-arrow-down': TaillessArrowDownAsm,
    'tailless-arrow-left': TaillessArrowLeftAsm,
    'tailless-arrow-right': TaillessArrowRightAsm,
    'tailless-arrow-up': TaillessArrowUpAsm,
    'tea-cup': TeaCupAsm,
    'text-snippet': TextSnippetAsm,
    'thumbs-up': ThumbsUpAsm,
    ticket: TicketAsm,
    tie: TieAsm,
    time: TimeAsm,
    'toilet-female': ToiletFemaleAsm,
    'toilet-male': ToiletMaleAsm,
    toilet: ToiletAsm,
    'transaction-history': TransactionHistoryAsm,
    transfer: TransferAsm,
    trophy: TrophyAsm,
    unpin: UnpinAsm,
    'user-female': UserFemaleAsm,
    'user-male': UserMaleAsm,
    visibility: VisibilityAsm,
    warning: WarningAsm,
    'weather-sunny': WeatherSunnyAsm,
    wine: WineAsm,
};

export const allIconComponents: Record<IconString, IconSVG> = allIconComponentsMcc;

interface IconProps {
    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    icon: IconString | string;
    className?: string;
    brand?: 'mcc' | 'mcg' | 'asm';
    // eslint-disable-next-line no-unused-vars
    onClick?: (event: ClickOrPressEvent) => void;
}

const Icon: React.FC<IconProps> = props => {
    const { icon, className, brand, onClick } = props;
    const iconName = kebabCase(icon) as IconString;

    // If brand is explicitly specified, use the original single-icon approach
    if (brand) {
        let iconSet: Record<IconString, IconSVG>;
        switch (brand) {
        case 'mcg':
            iconSet = allIconComponentsMcg;
            break;
        case 'asm':
            iconSet = allIconComponentsAsm;
            break;
        default:
            iconSet = allIconComponentsMcc;
        }

        const SpecificIcon = iconSet[iconName];

        if (!SpecificIcon) {
            return null;
        }

        const isClickableClass = onClick ? 'svg-icon-clickable' : '';
        const iconClass = `svg-icon ${isClickableClass} ${className ? className : ''}`;

        return <SpecificIcon onClick={onClick} className={iconClass} />;
    }

    // If no brand specified, render all brand variations and let CSS control visibility
    const brands = ['mcc', 'mcg', 'asm'] as const;
    const iconSets = {
        mcc: allIconComponentsMcc,
        mcg: allIconComponentsMcg,
        asm: allIconComponentsAsm,
    };

    const isClickableClass = onClick ? 'svg-icon-clickable' : '';
    const baseIconClass = `svg-icon ${isClickableClass} ${className ? className : ''}`;

    return (
        <>
            {brands.map(brandName => {
                const iconSet = iconSets[brandName];
                const SpecificIcon = iconSet[iconName];

                if (!SpecificIcon) {
                    return null;
                }

                const iconClass = `${baseIconClass} ${brandName}-icon`;

                return (
                    <SpecificIcon
                        key={brandName}
                        onClick={onClick}
                        className={iconClass}
                    />
                );
            })}
        </>
    );
};

export default Icon;
